import { GenIcon } from '../helpers/IconBase.es.js';

const CalendarOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.9674 4.43457C17.9674 4.02036 17.6316 3.68457 17.2174 3.68457C16.8032 3.68457 16.4674 4.02036 16.4674 4.43457V5H7.53261V4.43457C7.53261 4.02036 7.19682 3.68457 6.78261 3.68457C6.36839 3.68457 6.03261 4.02036 6.03261 4.43457V5H4.75C3.23122 5 2 6.23122 2 7.75V18.25C2 19.7688 3.23122 21 4.75 21H19.25C20.7688 21 22 19.7688 22 18.25V7.75C22 6.23122 20.7688 5 19.25 5H17.9674V4.43457ZM6.03261 6.5H4.75C4.05964 6.5 3.5 7.05964 3.5 7.75V9.25H20.5V7.75C20.5 7.05964 19.9404 6.5 19.25 6.5H17.9674V7.04327C17.9674 7.45748 17.6316 7.79327 17.2174 7.79327C16.8032 7.79327 16.4674 7.45748 16.4674 7.04327V6.5H7.53261V7.04327C7.53261 7.45748 7.19682 7.79327 6.78261 7.79327C6.36839 7.79327 6.03261 7.45748 6.03261 7.04327V6.5ZM3.5 10.75H20.5V18.25C20.5 18.9404 19.9404 19.5 19.25 19.5H4.75C4.05964 19.5 3.5 18.9404 3.5 18.25V10.75Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { CalendarOutlined };
